import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { referenceDBApi } from "@/services/api";
import type { ReferenceDBAssetCreate } from "@/types/referenceDBAsset";

/** admin 전용: 참조 DB asset 전체 목록 */
export function useReferenceDBAssets() {
  return useQuery({
    queryKey: ["reference-db-assets"],
    queryFn: async () => {
      const res = await referenceDBApi.list();
      return res.data;
    },
    staleTime: 2 * 60 * 1000,
  });
}

/** admin 전용: 참조 DB asset 단건 조회 */
export function useReferenceDBAsset(id: number) {
  return useQuery({
    queryKey: ["reference-db-assets", id],
    queryFn: async () => {
      const res = await referenceDBApi.get(id);
      return res.data;
    },
    enabled: id > 0,
  });
}

/** admin 전용: asset active 포인터 전환 */
export function useActivateReferenceDBAsset() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => referenceDBApi.activate(id).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reference-db-assets"] });
    },
  });
}

/** admin 전용: asset 등록(메타 등록 — 대용량은 CLI 권장) */
export function useRegisterReferenceDBAsset() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ReferenceDBAssetCreate) =>
      referenceDBApi.register(data).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reference-db-assets"] });
    },
  });
}
